/*
 * Copyright (C) Fraunhofer IESE 2021-2025 - Mher Ter-Tovmasyan
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import { isEmptyOrNull } from '@SLR/shared-library';
import { OrganizationType } from '@SLR/user-service-full-sdk';
import { OnboardingType } from 'configs';

export const getOnboardingType = (
  draftType?: OrganizationType,
  geoAreaId = ''
) => {
  if (draftType === OrganizationType.SolutionProvider) {
    return OnboardingType.SOLUTION_PROVIDER;
  } else if (isEmptyOrNull(geoAreaId)) {
    return OnboardingType.PUBLIC_AUTHORITIES;
  } else return OnboardingType.MUNICIPALITY;
};

export const getLastCommentDiv = (id: string, html?: string): string | null => {
  if (isEmptyOrNull(html)) return null;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const div = doc.querySelector(`div#${id}`);

  if (!div) return null;
  div.querySelectorAll('p').forEach((p: HTMLParagraphElement) => {
    p.style.fontSize = '14px';
  });
  return div.outerHTML;
};
